import React, { useState } from "react";
import Tilt from "react-parallax-tilt";
import { QRCodeSVG } from "qrcode.react";
import logo from './logo.png'
const DigitalPlatinumCard = () => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className="card-container pt-5">
      <Tilt glareEnable={true} glareMaxOpacity={0.25} scale={1.05} tiltMaxAngleX={10} tiltMaxAngleY={10}>
        <div className={`platinum-card ${flipped ? "flipped" : ""}`}>
          {/* Front Side */}
          <div className="card-face card-front p-4">
            <h5 className="brand-title text-center mb-4 d-flex align-items-center">
       <div className="logo-circle d-flex align-items-center justify-content-center me-3 bg-dark"><img src={logo} width='60' height='auto' className="rounded-5" alt="" />  </div>      SHAKSHI ENTERPRISES
            </h5>

            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
               
                  
                
                <div>
                  <h5 className="card-name mb-1">SUMIT BANSAL</h5>
                  <p className="card-role mb-1">PROPERITOR</p>
                  <p className="card-phone mb-0">+91 9215300187</p>
                </div>
              </div>
              <div className="qr-code-front">
                <QRCodeSVG
                  value={`BEGIN:VCARD
VERSION:3.0
N:SUMIT BANSAL
TEL:+919215300187
EMAIL:pdmsumit8aug@gmail.com
END:VCARD`}
                  size={100}
                  fgColor="#000000"
                />
               
              </div>
            </div>

            {/* <p className="address mt-4 small text-muted">
              <i className="fa fa-map-marker me-2"></i>
              Office No-306, 3rd Floor, RG Trade Tower, <br />
              Netaji Subhash Place, New Delhi - 110034
            </p> */}
          </div>

          {/* Back Side */}
          <div className="card-face card-back p-4">
            <h5 className="brand-title text-center mb-4 d-flex align-items-center">
       <div className="logo-circle d-flex align-items-center justify-content-center me-3 bg-dark"><img src={logo} className="rounded-5" width='60' height='auto' alt="" />  </div>      SHAKSHI ENTERPRISES
            </h5>

            <p className="address  small text-muted">
              <div> <i className="fa fa-map-marker me-2"></i> GR 94 GANPATI INDL AREA
DISTT-JHAJJAR BAHADUR GARH (HR)-124507</div>
            </p>
            <div className="qr-box ">
              <QRCodeSVG
                value="https://maps.app.goo.gl/KTRXNqp38hYML1Q38?g_st=iwb"
                size={80}
                fgColor="#000000"
              />
            </div>
          </div>
        </div>
      </Tilt>

      {/* Manual flip button */}
      <button
        className="platinum-btn mt-4 rounded-pill"
        onClick={() => setFlipped(!flipped)}
      >
        {flipped ? "Show Front" : "Show Back"}
      </button>

      {/* Action buttons */}
      <div className="d-flex flex-column gap-3 mt-5 w-75 mx-auto" style={{ maxWidth: "280px" }}>
        <a href="/sumit.vcf" download className="platinum-btn">Add To Contacts</a>
        <a href="tel:+919215300187" className="platinum-btn">Call Now</a>
        <a href="mailto:pdmsumit8aug@gmail.com" className="platinum-btn">Email Us</a>
        <a href="https://wa.me/919215300187" target="_blank" className="platinum-btn">
  WhatsApp
</a>

        {/* <a href="https://www.highxbrandindia.com/" target="_blank" rel="noopener noreferrer" className="platinum-btn">Website</a> */}
        <a href="https://maps.app.goo.gl/KTRXNqp38hYML1Q38?g_st=iwb" target="_blank" rel="noopener noreferrer" className="platinum-btn">Address & Location</a>
        {/* <a href="/brochure.pdf" download className="platinum-btn">Brochure</a> */}
      </div>
    </div>
  );
};

export default DigitalPlatinumCard;
